import { Navigate, Outlet, useNavigate, useParams } from "react-router-dom";
import classes from "../components/CommonGrid/commonGrid.module.css";
import {
  Button,
  Col,
  Form,
  Modal,
  Overlay,
  OverlayTrigger,
  Popover,
  Row,
  Tooltip,
} from "react-bootstrap";
import NumberFormat from "react-number-format";
import LoadingSpinner from "../components/Spinner";
import React, {
  cloneElement,
  isValidElement,
  useEffect,
  useRef,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setIsSavedReport,
  setReportDetail,
  setRunNewReport,
  setScheduledReportDetails,
} from "../store/reducers/reportDocumentSlice";
import moment from "moment";
import ErrorBoundary from "../components/ErrorBoundary";
import SSLNavbar from "../components/Navbar";
import {
  deleteSaveReport,
  deleteScheduledReport,
  fetchSaveReport,
  fetchScheduledReport,
} from "../store/reducers/reportDocumentSlice/api";
import { chooseReportLabelListRND } from "../pages/ReportsNDocuments/constantRND";
import { useAbortController } from "../hooks/useAbortController";
import {
  CloudDownload,
  Eye,
  EyeSlash,
  FileEarmarkText,
} from "react-bootstrap-icons";
import useAccountSelect from "../hooks/useAccountSelect";
import { Controller } from "react-hook-form";
import urls from "./urls";
import axiosInstance from "../axios";
import MfaNudgeHost from "../pages/Profile/security/nudge/MfaNudgeHost";

export const LoanAccCustomCell = (props) => {
  const totalAccountList = useSelector((state) => state.account.accountOptions);
  const { handleAccountSubmit } = useAccountSelect();

  const navigate = useNavigate();
  const row = props?.props?.row?.original;
  const selectedAccount = totalAccountList?.filter(
    (el) =>
      el.value === row?.loan_id ||
      el.value === row?.recid ||
      el.value === row?.loanRecID ||
      el.value === row?.loanrecid,
  );

  return (
    <BlurWrapperWithSpan>
      <div
        role="button"
        className={classes.buttonLinkClick}
        onClick={
          !props?.borrower
            ? () => {
                navigate(
                  "/loan-details/" +
                    (row?.loan_id ? row?.loan_id : row?.loan_recid),
                );
                // window.open(
                //   "/loan-details/" +
                //     (row?.loan_id ? row?.loan_id : row?.loan_recid),
                //   "_blank"
                // );
              }
            : () => handleAccountSubmit(selectedAccount?.[0])
        }
      >
        {props?.props?.value}
      </div>
    </BlurWrapperWithSpan>
  );
};

export const LoanAccForDefaults = (props) => {
  const navigate = useNavigate();
  const row = props?.props?.row?.original;

  return (
    <BlurWrapperWithSpan>
      <div
        role="button"
        className={classes.buttonLinkClick}
        onClick={
          row?.databasename !== "ROC"
            ? () => {
                navigate(
                  "/loan-details/" +
                    (row?.loan_id ? row?.loan_id : row?.loan_recid) +
                    "/defaults",
                );
                // window.open(
                //   "/loan-details/" +
                //     (row?.loan_id ? row?.loan_id : row?.loan_recid) +
                //     "/defaults",
                //   "_blank"
                // );
              }
            : () =>
                navigate(
                  "/loan-details/" +
                    (row?.loan_id ? row?.loan_id : row?.loan_recid),
                )
          // window.open(
          //   "/loan-details/" +
          //     (row?.loan_id ? row?.loan_id : row?.loan_recid),
          //   "_blank"
          // )
        }
      >
        {props?.props?.value}
      </div>
    </BlurWrapperWithSpan>
  );
};

export const LoanAccCustomCellForBorrowers = (props) => {
  const totalAccountList = useSelector((state) => state.account.accountOptions);

  const { handleAccountSubmit } = useAccountSelect();

  const navigate = useNavigate();
  const row = props?.props?.row?.original;
  const selectedAccount = totalAccountList?.filter(
    (el) =>
      el.value.split("-")[1] === row?.loan_id ||
      el.value.split("-")[1] === row?.recid ||
      el.value.split("-")[1] === row?.loanRecID ||
      el.value.split("-")[1] === row?.loanrecid,
  );

  return (
    <BlurWrapperWithSpan>
      <div
        role="button"
        className={classes.buttonLinkClick}
        onClick={() => handleAccountSubmit(selectedAccount?.[0])}
      >
        {props?.props?.value}
      </div>
    </BlurWrapperWithSpan>
  );
};
export const PayOffCustomCell = (props) => {
  const navigate = useNavigate();
  const row = props?.props?.row?.original;

  return (
    <BlurWrapperWithSpan>
      <div
        role="button"
        className={classes.buttonLinkClick}
        onClick={() => {
          navigate(`/demand-payoff/${row?.payoff_id}/${row?.status}`);
          // window.open(
          //   `/demand-payoff/${row?.payoff_id}/${row?.status}`,
          //   "_blank"
          // );
        }}
      >
        {props?.props?.value}
      </div>
    </BlurWrapperWithSpan>
  );
};

export const PayOffRequestCell = (props) => {
  const navigate = useNavigate();
  const row = props?.props?.row?.original;

  return (
    <BlurWrapperWithSpan>
      <div
        role="button"
        className={classes.buttonLinkClick}
        onClick={
          props?.isExternalBorrower
            ? () => {
                navigate(`/payoff-borrower-authorization`, {
                  state: {
                    source: "external-borrower",
                    status: row?.status,
                    loan_number: row?.account_number,
                    property_address: row?.property_address,
                    payoff_good_through_date: row?.payoff_good_through_date,
                    demand_expiration_date: row?.demand_expiration_date,
                    requestor_email: row?.requestor_email,
                    requestor_name: row?.requestor_name,
                    request_id: row?.request_id,
                    loanrecid: row?.loanrecid,
                  },
                });
              }
            : () => {
                navigate(`/payoff-request/details`, {
                  state: {
                    source: "third-party",
                    status: row?.status,
                    loan_number: row?.account_number,
                    property_address: row?.property_address,
                    payoff_good_through_date: row?.payoff_good_through_date,
                    demand_expiration_date: row?.demand_expiration_date,
                    requestor_email: row?.requestor_email,
                    requestor_name: row?.requestor_name,
                    request_id: row?.request_id,
                    loanrecid: row?.loanrecid,
                  },
                });
              }
        }
      >
        {props?.props?.value}
      </div>
    </BlurWrapperWithSpan>
  );
};

export const PayOffRequestCellV2 = (props) => {
  const navigate = useNavigate();
  const row = props?.props?.row?.original;

  return (
    <BlurWrapperWithSpan>
      <div
        role="button"
        className={classes.buttonLinkClick}
        onClick={() => {
          navigate(`/payoff-authorization`, {
            state: {
              source: "borrower",
              status: row?.status,
              loan_number: row?.account_number,
              property_address: row?.property_address,
              payoff_good_through_date: row?.payoff_good_through_date,
              demand_expiration_date: row?.demand_expiration_date,
              requestor_email: row?.requestor_email,
              requestor_name: row?.requestor_name,
              request_id: row?.request_id,
              loanrecid: row?.loanrecid,
            },
          });
          // window.open(
          //   `/demand-payoff/${row?.payoff_id}/${row?.status}`,
          //   "_blank"
          // );
        }}
      >
        {props?.props?.value}
      </div>
    </BlurWrapperWithSpan>
  );
};

export const LoanAccCustomCellParentRecID = (props) => {
  const navigate = useNavigate();
  const selectedRole = useSelector(
    (state) => state?.account?.selectedRole?.value,
  );

  const row = props?.props?.row?.original;

  return (
    <div
      role="button"
      className={classes.buttonLinkClick}
      onClick={
        selectedRole === "B"
          ? () => {
              // window.open(
              //   "/loan-details/" +
              //     (row?.ParentRecID ? row?.ParentRecID : row?.loanRecID),
              //   "_blank"
              // );
              navigate("/loan-details-borrower");
            }
          : () => {
              // debugger
              if (!row?.ParentRecID && !row?.loanRecID) {
                return;
              } else {
                // window.open(
                //   "/loan-details/" +
                //     (row?.ParentRecID ? row?.ParentRecID : row?.loanRecID),
                //   "_blank"
                // );
                navigate(
                  "/loan-details/" +
                    (row?.ParentRecID ? row?.ParentRecID : row?.loanRecID),
                );
              }
            }
      }
    >
      <BlurWrapperWithSpan>{props?.props?.value}</BlurWrapperWithSpan>
    </div>
  );
};
export const LoanAccCustomCellNewTab = (props) => {
  const navigate = useNavigate();
  const row = props?.props?.row?.original;
  return (
    <div
      role="button"
      className={classes.buttonLinkClick}
      onClick={() => {
        navigate(
          "/loan-details/" + (row?.loan_id ? row?.loan_id : row?.loan_recid),
        );
        // window.open(
        //   "/loan-details/" + (row?.loan_id ? row?.loan_id : row?.loan_recid),
        //   "_blank"
        // );
      }}
    >
      <BlurWrapperWithSpan>{props?.props?.value}</BlurWrapperWithSpan>
    </div>
  );
};
export const LoanAccCustomCellForSubrows = (props) => {
  const navigate = useNavigate();
  const row = props?.props?.row?.original;
  return props.props.row.depth === 1 ||
    props.props.row?.subRows?.length === 0 ? (
    <BlurWrapperWithSpan>
      <div
        role="button"
        className={classes.buttonLinkClick}
        onClick={() => {
          // window.open(
          //   "/loan-details/" + (row?.loan_id ? row?.loan_id : row?.loan_recid),
          //   "_blank"
          // );
          navigate(
            "/loan-details/" + (row?.loan_id ? row?.loan_id : row?.loan_recid),
          );
        }}
      >
        {props?.props?.value}
      </div>
    </BlurWrapperWithSpan>
  ) : (
    <BlurWrapperWithSpan>
      <span>{props?.props?.value}</span>
    </BlurWrapperWithSpan>
  );
};

export const LoanAccCustomCellForPropertyInfo = (props) => {
  const navigate = useNavigate();
  const row = props?.props?.row?.original;
  return (
    <BlurWrapperWithSpan>
      <div
        role="button"
        className={props?.isABorrower ? "" : classes.buttonLinkClick}
        onClick={
          !props?.isABorrower
            ? () => {
                navigate(
                  "/loan-details/" +
                    (row?.LoanRecID ? row?.LoanRecID : row?.LoanRecID) +
                    "/1",
                );
              }
            : null
        }
      >
        {props?.props?.value}
      </div>
    </BlurWrapperWithSpan>
  );
};

export const DollarConvert = (props) => {
  return (
    <NumberFormat
      displayType="text"
      value={props?.props?.value}
      prefix={"$"}
      customInput={false}
      fixedDecimalScale={true}
      decimalScale={2}
      thousandSeparator={true}
    />
  );
};

export const PercentageConvert = (props) => {
  return (
    <NumberFormat
      displayType="text"
      value={props?.props?.value}
      suffix={"%"}
      customInput={false}
      fixedDecimalScale={true}
      decimalScale={2}
    />
  );
};

export const DateConvert = (props) => {
  return props?.props?.value
    ? moment(new Date(props?.props?.value)).format("MM-DD-yyyy")
    : "";
};
export const NavigateButton = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const row = props?.props?.row?.original;

  const handleLinkClick = () => {
    // navigate(`/run-new-report/${row.report.value}`);
    // navigate(`/run-new-report/${row.loanId}`);
    // const options =
    //   chooseReportLabelListRND?.filter(
    //     // (data) => data.value === row.report.value
    //     (data) => data.value === row.report_details.report.value
    //   )?.[0]?.options || [];
    dispatch(
      setRunNewReport({
        // report: row.report,
        // reportName: row.report.label,
        // options: options,
        // lenderID: row.lenderID,
        // propState: row.propState,
        report: row?.report_details?.report,
        reportName: row?.report_details?.report.label,
        // options: options,
        options: row?.report_details?.propState,
        lenderID: row?.report_details?.lenderID,
        propState: row?.report_details?.propState,
      }),
    );
    dispatch(setReportDetail({ options: row?.report_details?.propState }));
    dispatch(setIsSavedReport(true));
    navigate(`/run-new-report/${row.loanId}`);
  };
  return (
    <div role="button" className={"linkClick"} onClick={handleLinkClick}>
      <BlurWrapperWithSpan>{props?.props?.value}</BlurWrapperWithSpan>
    </div>
  );
};

export const NavigateButtonForScheduleReport = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const row = props?.props?.row?.original;

  function handleLinkClick() {
    const payload = {
      ...row?.reportData,
      id: row.id,
    };
    dispatch(setScheduledReportDetails(payload));
    navigate("/schedule-report", {
      state: { prefilled: true, reportId: row.id },
    });
  }

  return (
    <div role="button" className={"linkClick"} onClick={handleLinkClick}>
      <BlurWrapperWithSpan>{props?.props?.value}</BlurWrapperWithSpan>
    </div>
  );
};

export const DeleteScheduleButton = (props) => {
  const { signal } = useAbortController();
  const ref = useRef(null);
  const [show, setShow] = useState(false);
  const [target, setTarget] = useState(null);
  const masqueradeEmail = useSelector(
    (state) => state.RS_Authentication.masquerade,
  );
  const email = useSelector(
    (state) => state.RS_Authentication.user.details.email,
  );
  const dispatch = useDispatch();
  const row = props?.props?.row?.original;
  const userId = localStorage.getItem("apex_userid");

  const handleLinkClick = () => {
    const payloadForDelete = {
      sch_id: row.id,
      user_id: userId,
      deleted_by:
        masqueradeEmail?.isIt == true
          ? masqueradeEmail?.p_logged_in_email
          : email,
    };

    dispatch(
      deleteScheduledReport({
        id: row.id,
        fetchSave: () => dispatch(fetchScheduledReport({ signal })),
        signal,
        payloadForDelete,
      }),
    );
  };
  const handleClick = (event) => {
    setShow(!show);
    setTarget(event.target);
  };
  return (
    <div ref={ref} className="d-flex justify-content-start align-items-center">
      <div role="button" className={"linkClick"} onClick={handleClick}>
        Delete
      </div>
      <Overlay
        show={show}
        target={target}
        container={ref}
        containerPadding={20}
        placement="bottom"
      >
        <Popover id="popover-contained">
          <Popover.Header as="h3" className="bg-primary text-white">
            Are you sure ?
          </Popover.Header>
          <Popover.Body>
            <div className="d-flex justify-content-between">
              <div
                role="button"
                className={"linkClick"}
                onClick={handleLinkClick}
              >
                Ok
              </div>
              <div role="button" onClick={() => setShow(!show)}>
                cancel
              </div>
            </div>
          </Popover.Body>
        </Popover>
      </Overlay>
    </div>
  );
};
export const DeleteSavedButton = (props) => {
  const { signal } = useAbortController();
  const dispatch = useDispatch();
    const masqueradeEmail = useSelector(
    (state) => state.RS_Authentication.masquerade,
  );
  const email = useSelector(
    (state) => state.RS_Authentication.user.details.email,
  );
  const userId = localStorage.getItem("apex_userid");
  const row = props?.props?.row?.original;

  const handleLinkClick = () => {
    const payloadForDelete = {
      sch_id: row.id,
      user_id: userId,
      deleted_by:
        masqueradeEmail?.isIt == true
          ? masqueradeEmail?.p_logged_in_email
          : email,
    };

    dispatch(
      deleteSaveReport({
        id: row.id,
        fetchSave: () => dispatch(fetchSaveReport({ signal })),
        signal,
        payloadForDelete
      }),
    );
  };

  return (
    <OverlayTrigger
      trigger="click"
      placement="bottom"
      rootClose
      overlay={
        <Popover id="popover-trigger-click-root-close">
          <Popover.Header as="h3" className="bg-primary text-white">
            Are you sure ?
          </Popover.Header>
          <Popover.Body>
            <div className="d-flex justify-content-center">
              <div
                role="button"
                className={"linkClick"}
                onClick={handleLinkClick}
              >
                Ok
              </div>
            </div>
          </Popover.Body>
        </Popover>
      }
    >
      <div role="button" className={"linkClick"}>
        Delete
      </div>
    </OverlayTrigger>
  );
};
export const StatusChip = (props) => {
  const status = props?.props?.value;

  return (
    <>
      {status === "pending" ? (
        <>
          <div
            style={{
              background: "rgb(255, 211, 129,0.3)",
              display: "inline",
              padding: "8px",
              borderRadius: "5px",
              color: "rgb(255, 169, 0)",
            }}
          >
            <span
              style={{
                background: "rgb(255, 169, 0)",
                height: "8px",
                width: "8px",
                borderRadius: "50%",
                display: "inline-block",
                marginRight: "4px",
              }}
            ></span>
            Pending
          </div>
        </>
      ) : status === "received" ? (
        <div
          style={{
            background: "#37b4001c",
            display: "inline",
            padding: "8px",
            borderRadius: "5px",
            color: "#37b400",
          }}
        >
          Received
        </div>
      ) : (
        <div
          style={{
            background: "#0d6efd42",
            display: "inline",
            padding: "8px",
            borderRadius: "5px",
            color: "#0058e9",
          }}
        >
          status
        </div>
      )}
    </>
  );
};
export const LoanYearsSelect = ({
  loanYears,
  setLoanYearSelect,
  loanYearSelect,
}) => {
  return (
    <Form.Select
      value={loanYearSelect}
      onChange={(e) => setLoanYearSelect(e.currentTarget.value)}
      style={{ width: "auto" }}
    >
      {loanYears?.map((data, index) => (
        <option key={index} value={data}>
          Year {data}
        </option>
      ))}
    </Form.Select>
  );
};
export const SpinnerBlock = ({ height = "40vh", className = "" }) => {
  return (
    <div
      className={`${
        height === "40vh" ? "rounded col-sm-6" : "col-sm-12"
      } ${className}`}
    >
      <div className="m-2 bg-white p-3 rounded" style={{ height: height }}>
        <div className="d-flex align-items-center justify-content-between my-3">
          <span className="mb-2"></span>
        </div>
        <LoadingSpinner />
      </div>
    </div>
  );
};
export const FloatLabel = (props) => {
  const [focus, setFocus] = useState(false);
  const { children, label, value, divClassName } = props;

  const labelClass =
    focus || (value && value?.length !== 0)
      ? `flabel label-float ${props?.className}`
      : `flabel ${props?.className}`;

  return (
    <div
      className={`float-label ${divClassName}`}
      onBlur={() => setFocus(false)}
      onFocus={() => setFocus(true)}
    >
      {children}
      <label className={labelClass}>{label}</label>
      <style>
        {`.float-label {
            position: relative;
            margin-bottom: 12px;
          }
          .flabel {
            font-size: 16px;
            font-weight: normal;
            color:darkgrey;
            position: absolute;
            pointer-events: none;
            left: 12px;
            top: 12px;
            transition: 0.2s ease all;
          }
          .label-float {
            background: white;
            width: auto;
            top: -10px;
            padding: 0 6px;
            font-size: 12px;
          }
          `}
      </style>
    </div>
  );
};
export const LiButton = ({ activeTab, setActiveTab, label, value }) => {
  return (
    <li className="nav-item col ">
      <button
        className={
          activeTab === value
            ? "btn h-100 text-primary w-100 d-flex justify-content-center rounded-0"
            : "btn h-100 w-100 d-flex justify-content-center rounded-0 inactiveHover"
        }
        style={{
          borderBottomColor: activeTab === value ? "#ef8860" : "",
        }}
        aria-current="page"
        href="#"
        onClick={() => {
          setActiveTab(value);
        }}
      >
        {label}
      </button>
    </li>
  );
};
export const LiHandleButton = ({
  activeTab,
  handleBtnClick,
  label,
  value,
  flash = false,
  count=0
}) => {
  return (
    <li className="nav-item">
      <button
        className={
          activeTab === value
            ? `btn h-100 text-primary w-100 d-flex justify-content-center align-items-center rounded-0 ${flash ? "flashing-badge" : "flashing-none"}`
            : `btn h-100 w-100 d-flex justify-content-center rounded-0 inactiveHover flashing-badge ${flash ? "flashing-badge" : "flashing-none"}`
        }
        style={{
          borderBottomColor: activeTab === value ? "#ef8860" : "",
        }}
        aria-current="page"
        href="#"
        onClick={() => handleBtnClick(value)}
      >
        {label}
        {count > 0 && (
          <span className="badge rounded-pill bg-error ms-2 pt-3">
            {count}
          </span>
        )}
      </button>
    </li>
  );
};
export const LoadingButton = ({
  type,
  onClick,
  title,
  loading,
  className,
  disabled,
}) => {
  return (
    <Button
      disabled={disabled}
      className={className}
      onClick={onClick}
      type={type}
    >
      <div className="d-flex justify-content-center align-items-center">
        <div className="me-3">{title}</div>
        {loading && (
          <div
            style={{ height: "1.2rem", width: "1.2rem" }}
            className="spinner-border"
            role="status"
          />
        )}
      </div>
    </Button>
  );
};

export const RootWrapper = () => {
  const routeState = useSelector((state) => state.RS_Authentication.route);
  const sidebarVisibility = useSelector((state) => state.RS_Sidebar.show);
  const sidebarWidth = useSelector((state) => state.RS_Sidebar.sidebarWidth);
  const masqueradeEmail = useSelector(
    (state) => state.RS_Authentication.masquerade,
  );

  return routeState?.length ? (
    <div
      className="dashboard-wrapper"
      style={{
        marginLeft: sidebarVisibility ? "calc(" + sidebarWidth + ")" : "0px",
        marginTop: masqueradeEmail.isIt
          ? "calc(90px + 0px)"
          : "calc(60px + 0px)",
        transition: "all .3s ease-in-out",
      }}
    >
      <ErrorBoundary>
        <SSLNavbar />
      </ErrorBoundary>
      <div className="text-start container-fluid my-4 px-0">
        <Outlet />
      </div>
      <MfaNudgeHost />
    </div>
  ) : (
    <>
      <Outlet />
    </>
  );
};

export const LoanAccCustomNewTabCell = ({ props, keyStr = "Loan Account" }) => {
  const navigate = useNavigate();
  const row = props?.row?.original;

  const ExtractAccount = () => {
    let htmlObject = document.createElement("div");
    htmlObject.innerHTML = row?.[keyStr];
    const loanAccName = htmlObject?.getElementsByTagName("a")?.[0]?.innerHTML;

    const loanAccKey = htmlObject
      ?.getElementsByTagName("a")[0]
      ?.getAttribute("href")
      ?.split("/")[2];

    return (
      <div
        role="button"
        className={classes.buttonLinkClick}
        onClick={() => {
          // window.open("/loan-details/" + loanAccKey, "_blank");
          navigate("/loan-details/" + loanAccKey);
        }}
      >
        <BlurWrapperWithSpan>{loanAccName}</BlurWrapperWithSpan>
      </div>
    );
  };

  return row?.loan_id || row?.loanrecid ? (
    <div
      role="button"
      className={classes.buttonLinkClick}
      onClick={() => {
        //  window.open(
        //     "/loan-details/" + (row?.loan_id ? row?.loan_id : row?.loanrecid),
        //     "_blank"
        //   );
        navigate(
          "/loan-details/" + (row?.loan_id ? row?.loan_id : row?.loanrecid),
        );
      }}
    >
      <BlurWrapperWithSpan>{row?.account}</BlurWrapperWithSpan>
    </div>
  ) : row?.[keyStr]?.includes("<a href") ? (
    <ExtractAccount />
  ) : (
    <BlurWrapperWithSpan>{props.value}</BlurWrapperWithSpan>
  );
};
export const FloatLabelInput = ({
  label,
  register,
  type = "text",
  value,
  disabled = false,
  className = "",
  error = "",
  disablePaste = false,
  control,
  field,
  setValue,
  rows = 2,
}) => {
  const handlePaste = (e) => {
    e.preventDefault();
  };

  return (
    <>
      <div className={`form-group ${className}`}>
        <FloatLabel
          label={label}
          value={type === "date" || type === "file" ? "1" : value}
          className={error?.length ? "text-error" : ""}
        >
          {type === "textarea" ? (
            <textarea
              type={type}
              className={`form-control input-lg p-5 ${
                error?.length ? "is-invalid" : ""
              }`}
              {...register}
              disabled={disabled}
              rows={rows}
            ></textarea>
          ) : type === "email" ? (
            <input
              type="email"
              className={`form-control input-lg p-5 ${
                error?.length ? "is-invalid" : ""
              }`}
              {...register}
              readOnly={disabled}
            />
          ) : type === "amount" ? (
            <Controller
              name={field}
              control={control}
              render={({ field: { onChange, value, ref } }) => (
                <NumberFormat
                  value={value}
                  onValueChange={(values) => {
                    onChange(values.floatValue ?? ""); // send raw number to react-hook-form
                  }}
                  className={`form-control input-lg p-5 ${
                    error?.length ? "is-invalid" : ""
                  }`}
                  thousandSeparator
                  prefix="$"
                  decimalScale={2}
                  fixedDecimalScale
                  allowNegative={false}
                  inputRef={ref}
                  customInput="input" // or use a component like TextField
                  displayType={disabled ? "text" : "input"}
                />
              )}
            />
          ) : (
            //   )}
            // />
            <input
              type={type}
              className={`form-control input-lg p-5 ${
                error?.length ? "is-invalid" : ""
              }`}
              {...register}
              readOnly={disabled}
              onPaste={disablePaste ? handlePaste : null}
            />
          )}
          <div className="invalid-feedback">{error}</div>
        </FloatLabel>
        <style>
          {`
          .form-control:focus{
          border-color:#f19a78;
          box-shadow:0 0 0 0.25rem #f19a788c;
          }
          `}
        </style>
      </div>
    </>
  );
};
export const LabelInput = ({ labelProps, inputProps, error }) => {
  return (
    <>
      <label className={`mb-2 ${labelProps?.className}`} {...labelProps?.props}>
        {labelProps?.title}
      </label>
      <input style={{ height: "48px" }} {...inputProps} />
      <div className="invalid-feedback">{error}</div>
    </>
  );
};

export function daysToMonthsAndDays(days) {
  const absoluteDays = Math.abs(days);
  const duration = moment.duration(absoluteDays, "days");
  const months = duration.months();
  const remainingDays = duration.days();
  return `${months} month${months !== 1 ? "s" : ""} ago, ${remainingDays} day${
    remainingDays !== 1 ? "s" : ""
  } ago`;
}

export function daysToMonthsAndDaysV2(days) {
  const currentDate = new Date();
  const targetDate = new Date(currentDate);

  if (days > 0) {
    // Calculate future date
    targetDate.setDate(targetDate.getDate() + days);
    const daysDifference = Math.floor(
      (targetDate - currentDate) / (24 * 60 * 60 * 1000),
    );
    const months = Math.floor(daysDifference / 30);
    const daysRemaining = daysDifference % 30;

    if (months === 0) {
      return `${daysRemaining} days`;
    } else if (daysRemaining === 0) {
      return `${months} months`;
    } else {
      return `${months} months and ${daysRemaining} days`;
    }
  } else if (days < 0) {
    // Calculate past date
    targetDate.setDate(targetDate.getDate() - Math.abs(days));
    const timeDifference = currentDate - targetDate;
    const daysAgo = Math.floor(timeDifference / (24 * 60 * 60 * 1000));
    const monthsAgo = Math.floor(daysAgo / 30);
    const remainingDays = daysAgo % 30;

    if (monthsAgo === 0) {
      return `${remainingDays} days ago`;
    } else if (remainingDays === 0) {
      return `${monthsAgo} months ago`;
    } else {
      return `${monthsAgo} months and ${remainingDays} days ago`;
    }
  } else {
    return "Today";
  }
}
export const customStylesForMultiSelect = {
  control: (provided, state) => ({
    ...provided,
    minHeight: "58px",
    minWidth: "250px",
  }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    minHeight: "50px",
  }),
  container: (base) => ({
    ...base,
    width: "100%",
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999,
    position: "absolute",
  }),
};
// function trimStringTo5Characters(inputString) {
//   if (inputString?.length <= 5) {
//     return inputString;
//   } else {
//     return inputString.substring(0, 5);
//   }
// }

export const IncidentIdCustomCell = (props) => {
  const navigate = useNavigate();

  return (
    <div
      role="button"
      className={classes.buttonLinkClick}
      onClick={() => {
        navigate(
          "/support/" +
            props.props.values.id +
            "/" +
            props.props?.original?.incident_number,
        );
      }}
    >
      {/* {trimStringTo5Characters(props.props.values.id)} */}
      <BlurWrapperWithSpan>
        {props.props?.original?.incident_number}
      </BlurWrapperWithSpan>
    </div>
  );
};
export const removeBrTags = (value, replaceWith) => {
  return value.replace(/<br\s*\/?>/gi, replaceWith);
};

export const extractLenderAccountValue = (lenderAccount) => {
  const match = lenderAccount.match(/>([^<]+)<\/a>/);
  return match ? match[1] : "";
};

export const calculateDaysOld = (dateString) => {
  const dateObject = new Date(dateString);
  const currentDate = new Date();
  const dateDifference = currentDate - dateObject;
  const days = Math.floor(dateDifference / (1000 * 60 * 60 * 24));
  return days;
};

export const Dot = ({ size = "12px", color }) => {
  const dotStyle = {
    width: size,
    height: size,
    borderRadius: "50%",
    backgroundColor: color,
    display: "inline-block",
  };

  return <div style={dotStyle}></div>;
};

export const AttachmentCell = ({ value }) => {
  if (value.title) {
    return (
      <div>
        <a href={value.href} target="_blank" rel="noreferrer">
          {value.title}
        </a>
      </div>
    );
  }

  return <div></div>;
};

export const MaskWrapper = ({ children }) => {
  const existingProps = children.props;

  const [isHovered, setIsHovered] = useState(false);

  const combinedClassName = [
    existingProps.className, // Existing class names
    isHovered ? "noBlurField" : "blurField", // New class name based on isHovered
  ]
    .filter(Boolean) // Filter out falsy values and join with space
    .join(" ");

  // Function to handle mouse enter event
  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  // Function to handle mouse leave event
  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const cloneChildWithProps = (child) => {
    // Clone the child element and add properties
    return cloneElement(child, {
      ...existingProps, // Spread existing props
      className: combinedClassName,
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
    });
  };

  return <>{cloneChildWithProps(children)}</>;
};

export const BlurWrapper = ({ children }) => {
  const isDemoAccount = useSelector((state) => state.account.isDemoAccount);
  const existingProps = children?.props;

  const combinedClassName = [
    existingProps?.className, // Existing class names
    "blurField", // New class name based on isHovered
  ]
    .filter(Boolean) // Filter out falsy values and join with space
    .join(" ");

  // Function to handle mouse enter event

  const cloneChildWithProps = (child) => {
    // Clone the child element and add properties
    return cloneElement(child, {
      ...existingProps, // Spread existing props
      className: combinedClassName,
    });
  };

  return isDemoAccount ? <>{cloneChildWithProps(children)}</> : <>{children}</>;
};

export const BlurWrapperWithSpan = ({ children, blurLevel = 5 }) => {
  const isDemoAccount = useSelector((state) => state.account.isDemoAccount);
  return isDemoAccount ? (
    <span
      style={{
        filter: `blur(${blurLevel}px)`,
      }}
    >
      {children}
    </span>
  ) : (
    <>{children}</>
  );
};

export const EyeIconWrapper = ({
  children,
  top = "16px",
  inputProps = false,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const existingProps = children.props;
  const childrenArray = React.Children.toArray(children);

  const combinedStyle = { ...existingProps.style, position: "relative" };
  const newType = showPassword ? "text" : "password";
  const newDiv = (
    <div
      style={{
        position: "absolute",
        top: top,
        right: "2rem",
        cursor: "pointer",
      }}
      onClick={() => setShowPassword((pass) => !pass)}
    >
      {showPassword ? <Eye size={20} /> : <EyeSlash size={20} />}
    </div>
  );

  const cloneChildWithProps = isValidElement(childrenArray[0])
    ? (child) => {
        return cloneElement(child, {
          ...existingProps,
          style: combinedStyle,
          // type: newType,
          children: (
            <>
              {React.Children.map(
                childrenArray[0].props.children,
                (grandChild) => {
                  if (!isValidElement(grandChild)) return grandChild;

                  if (inputProps) {
                    const existingInputProps =
                      grandChild.props.inputProps || {};

                    return cloneElement(grandChild, {
                      inputProps: {
                        ...existingInputProps,
                        type: newType,
                      },
                    });
                  } else {
                    return cloneElement(grandChild, {
                      type: newType,
                    });
                  }
                },
              )}

              {newDiv}
            </>
          ),
        });
      }
    : children[0];

  return <>{cloneChildWithProps(children)}</>;
};

export const FloatLabelFormattedInput = ({
  label,
  register,
  type = "text",
  value,
  disabled = false,
  className = "",
  error = "",
  pattern,
  setValue,
  watch,
}) => {
  const [formattedInput, setFormattedInput] = useState("");
  const unmaskedVal = watch("unmaskedTIN");

  useEffect(() => {
    handleInputChange(value);
  }, [value, label, pattern]);

  const handleInputChange = (event) => {
    let value;
    value = event?.target ? event.target.value : event;
    if (value?.includes("*")) {
      value = unmaskedVal?.slice(0, value.length);
    }

    const numericValue = value.replace(/\D/g, "");

    if (pattern?.includes("-")) {
      const patternArr = pattern.split("-");
      const a = patternArr[0].length;
      const b = patternArr[1].length;
      const c = a + b;

      let formattedValue = "";
      if (numericValue.length <= a) {
        formattedValue = numericValue;
      } else if (numericValue.length <= c) {
        formattedValue = `${numericValue.slice(0, a)}-${numericValue.slice(a)}`;
      } else {
        formattedValue = `${numericValue.slice(0, a)}-${numericValue.slice(
          a,
          c,
        )}-${numericValue.slice(c)}`;
      }
      setValue("unmaskedTIN", formattedValue);
      const maskedVal = maskTINWithSplice(formattedValue);
      setFormattedInput(maskedVal);
    } else {
      let newVal;
      if (value?.includes("-")) {
        newVal = value.replace(/-/g, "");
      } else {
        newVal = value;
      }
      setValue("unmaskedTIN", newVal);
      const maskedVal = maskTINWithSplice(newVal);
      setFormattedInput(maskedVal);
    }
  };

  function maskTINWithSplice(value) {
    if (!value) return "";

    let valueArray = value.split("");

    // Ensure the value is in the correct format
    if (value.match(/^\d{9}$/)) {
      valueArray.splice(0, 5, "*", "*", "*", "*", "*");
    } else if (value.match(/^\d{3}-\d{2}-\d{4}$/)) {
      valueArray.splice(0, 3, "*", "*", "*");
      valueArray.splice(4, 2, "*", "*");
    } else if (value.match(/^\d{2}-\d{7}$/)) {
      valueArray.splice(0, 2, "*", "*");
      valueArray.splice(3, 3, "*", "*", "*");
    }

    // Convert the array back to a string
    return valueArray.join("");
  }

  return (
    <>
      <div className={`form-group ${className}`}>
        <FloatLabel
          label={label}
          value={value}
          className={error?.length ? "text-error" : ""}
        >
          <BlurWrapperWithSpan>
            <input
              type={type}
              className={`form-control input-lg p-5 ${
                error?.length ? "is-invalid" : ""
              }`}
              {...register}
              disabled={disabled}
              value={formattedInput}
              maxLength={11}
            />
          </BlurWrapperWithSpan>

          <div className="invalid-feedback">{error}</div>
        </FloatLabel>
        <style>
          {`
          .form-control:focus{
          border-color:#f19a78;
          box-shadow:0 0 0 0.25rem #f19a788c;
          }
          `}
        </style>
      </div>
    </>
  );
};

export const ExtractValue = ({ value }) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = value;

  // Select the actual <span> element from the temporary div
  const spanElement = tempDiv?.querySelector("span");

  // Extract the value of the aria-hidden attribute
  const ariaHiddenValue = spanElement?.getAttribute("aria-hidden");
  return <>{ariaHiddenValue}</>;
};

export const DeleteButton = ({ onClick, icon = null, disable = false }) => {
  const button = icon ? (
    <Button
      className="p-0 border-0 bg-transparent shadow-none"
      disabled={disable}
    >
      {icon}
    </Button>
  ) : (
    <Button className="btn btn-error" disabled={disable}>
      Delete
    </Button>
  );

  return disable ? (
    <OverlayTrigger
      placement="top"
      overlay={
        <Tooltip id="disabled-tooltip">
          This account cannot be edited or deleted because it is tied to a loan ACH info.
        </Tooltip>
      }
    >
      <span className="d-inline-block">{button}</span>
    </OverlayTrigger>
  ) : (
    <OverlayTrigger
      trigger="click"
      placement="bottom"
      rootClose
      overlay={
        <Popover id="popover-trigger-banking">
          <Popover.Header as="h3" className="bg-primary text-white">
            Are you sure?
          </Popover.Header>

          <Popover.Body>
            <div className="d-flex justify-content-center">
              <div role="button" className="linkClick" onClick={onClick}>
                Ok
              </div>
            </div>
          </Popover.Body>
        </Popover>
      }
    >
      {button}
    </OverlayTrigger>
  );
};

const legends = [
  { color: "green", label: "Current" },
  { color: "yellow", label: "Expiring in\n30 Days" },
  { color: "#f57c00", label: "No Proof /\nLapse of\nInsurance" },
  { color: "black", label: "Forced Placed\nCurrent" },
  { color: "red", label: "Forced Placed\nExpires in\n30 days" },
];
export const Legend = () => (
  <div className="d-flex flex-row align-items-start flex-wrap gap-3">
    {legends.map((item, idx) => (
      <div key={idx} className="d-flex align-items-center">
        <div
          style={{
            width: "24px",
            height: "24px",
            borderRadius: "4px",
            backgroundColor: item.color,
            marginRight: "6px",
            marginTop: "4px",
          }}
        />
        <div
          style={{
            whiteSpace: "pre-line",
            fontSize: "0.6rem",
            lineHeight: "1",
          }}
        >
          {item.label}
        </div>
      </div>
    ))}
  </div>
);

const weekDays = [
  { title: "Every Sunday", value: "0" },
  { title: "Every Monday", value: "1" },
  { title: "Every Tuesday", value: "2" },
  { title: "Every Wednesday", value: "3" },
  { title: "Every Thursday", value: "4" },
  { title: "Every Friday", value: "5" },
  { title: "Every Saturday", value: "6" },
];

export const HandleFrequency = (props) => {
  const row = props?.props?.row?.original;

  if (!row?.repeat) {
    return "-";
  }

  if (row?.frequency?.Repeat === "D") {
    return <div>Every Day</div>;
  }

  if (row?.frequency?.Repeat === "W") {
    const filteredDay = weekDays?.filter(
      (el) => el.value == row?.frequency?.Day,
    );
    return <div>{filteredDay?.[0]?.title}</div>;
  }

  if (row?.frequency?.Repeat === "M") {
    return <div>Every Month</div>;
  }
};

export const TaxFormsAnnouncement = () => {
  const [show, setShow] = useState(true);
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState(null);
  const role = useSelector((state) => state?.account?.selectedRole?.value);

  // useEffect(() => {
  //   if (role) {
  //     showTaxForm(role);
  //   }
  // }, [role]);

  // async function showTaxForm(role) {
  //   try {
  //     setLoading(true);
  //     const res = await axios.get(urls.dashboard.showTaxFormMarquee, {
  //       headers: {
  //         account_type: role,
  //         "Content-Type": "application/json",
  //         Authorization: "Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==",
  //       },
  //     });
  //     const data = res?.data?.items?.[0] ?? null;
  //     setNotification(data);
  //     if (data?.notification_name) {
  //       setShow(true);
  //     } else {
  //       setShow(false);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     setNotification(null);
  //     setShow(false);
  //   } finally {
  //     setLoading(false);
  //   }
  // }

  if (!show) return null;

  return (
    <>
      {loading ? (
        <Row className="mb-1 gx-0">
          <Col md={12} className="px-3 py-4">
            <div
              className="d-flex align-items-center justify-content-center p-4 rounded"
              style={{ minHeight: "80px" }}
            >
              <SpinnerBlock height="10vh" />
            </div>
          </Col>
        </Row>
      ) : (
        <div
          className="alert d-flex align-items-start justify-content-between rounded-3 py-4 px-4 mb-4"
          style={{ background: "#f6fff7", border: "1px solid #b7e4c7" }}
        >
          <div className="d-flex align-items-start">
            <span className="me-3 fs-4">
              <FileEarmarkText />
            </span>

            <div>
              <div className="fw-bold text-success fs-5">
                {/* {notification?.notification_name} */}
                Tax Forms Are Now Available
              </div>
              <div className="text-dark mt-1">
                {/* {notification?.notification_description} */}
                1098 / 1099 – You can download by going to the{" "}
                <strong>Attachments</strong> section.
              </div>
            </div>
          </div>

          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => setShow(false)}
          />
        </div>
      )}
    </>
  );
};

export const isValidEmail = (value) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
};

export const VOMProtectedRoute = ({ children }) => {
  const [isVerified, setIsVerified] = useState(null); // null = loading
  const { email } = useParams();

  useEffect(() => {
    const verifyUser = async () => {
      try {
        const token = localStorage.getItem("vom_token");

        if (!token) {
          setIsVerified(false);
          return;
        }

        const res = await axiosInstance.get(
          urls.VOM.vaildateEmailOnRoute(email),
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        if (res.status === 200) {
          setIsVerified(true);
        } else {
          setIsVerified(false);
        }
      } catch (error) {
        console.error("VOM auth failed:", error);
        localStorage.removeItem("vom_token");
        setIsVerified(false);
        alert("Invalid or expired token");
      }
    };

    verifyUser();
  }, []);

  // ⏳ Loading state (prevents route flicker)
  if (isVerified === null) {
    return (
      <div style={{ marginTop: "130px" }}>
        <SpinnerBlock />
      </div>
    );
  }

  // ❌ Not verified
  if (!isVerified) {
    return <Navigate to="/vom-gateway" replace />;
  }

  // ✅ Verified
  return children;
};

export const DownloadButtonForReports = ({
  props
}) => {
  function handleDownload() {
    const a = document.createElement("a");
    a.href = props?.row?.original.file_url;
    a.download = props?.row?.original.file_name;
    document.body.appendChild(a);
    a.click();
    a.remove();
  }

  return (
    <button
      style={{
        border: "none",
        background: "#e9f1ff",
        color: "#295fbe",
        borderRadius: "6px",
        padding: "6px 10px",
        fontSize: "12px",
        fontWeight: 500,
      }}
      onClick={handleDownload}
    >
      <CloudDownload /> Download
    </button>
  );
};

export const PayoffProtectedRoute = ({ children }) => {
  const [isVerified, setIsVerified] = useState(null); // null = loading

  useEffect(() => {
    const verifyUser = async () => {
      try {
        const token = localStorage.getItem("payoff_token");
        const email = localStorage.getItem("email_for_payoff");

        if (!token) {
          setIsVerified(false);
          return;
        }

        const res = await axiosInstance.get(
          urls.payOffDemand.vaildateEmailOnRoute(email),
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        if (res.data.message === "success") {
          setIsVerified(true);
        } else {
          setIsVerified(false);
        }
      } catch (error) {
        console.error("Payoff auth failed:", error);
        localStorage.removeItem("payoff_token");
        setIsVerified(false);
        alert("Invalid or expired token");
      }
    };

    verifyUser();
  }, []);

  // ⏳ Loading state (prevents route flicker)
  if (isVerified === null) {
    return (
      <div style={{ marginTop: "130px" }}>
        <SpinnerBlock />
      </div>
    );
  }

  // ❌ Not verified
  if (!isVerified) {
    return <Navigate to="/payoff-gateway" replace />;
  }

  // ✅ Verified
  return children;
};

export const ExistingPayoffRequestModal = ({
  show,
  onClose,
  loanNumber,
  requestDate,
  payoffRequestId,
}) => {
  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      size="lg"
      backdrop="static"
      dialogClassName="payoff-request-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Request Payoff</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="payoff-existing-container">
          {/* Info / Warning Message */}
          <div className="payoff-existing-alert">
            <div className="payoff-info-icon">
              <span>i</span>
            </div>

            <div className="payoff-alert-content">
              <div className="payoff-alert-title">
                Payoff Request Already Exists
              </div>

              <div className="payoff-alert-message">
                A payoff request for this loan has already been submitted in the
                system.
                <br />
                {/* Please view the existing request for more details. */}
              </div>
            </div>
          </div>

          {/* Loan / Request Details */}
          <div className="payoff-details mt-5">
            <h5 className="payoff-details-title">Existing Payoff Request</h5>

            <div className="row mt-4">
              {/* Loan Number */}
              <div className="col-md-4 mb-4">
                <div className="payoff-detail-label">Loan Number</div>
                <div className="payoff-detail-value">{loanNumber}</div>
              </div>

              {/* Request Date */}
              <div className="col-md-4 mb-4">
                <div className="payoff-detail-label">Request Date</div>
                <div className="payoff-detail-value">{requestDate}</div>
              </div>

              {/* Request ID */}
              <div className="col-md-4 mb-4">
                <div className="payoff-detail-label">Request Number</div>
                <div className="payoff-detail-value">{payoffRequestId ? payoffRequestId : "-"}</div>
              </div>
            </div>
          </div>
          {/* Footer Actions */}
          {/* <div className="payoff-existing-footer">
            <Button
              className="payoff-view-button"
              onClick={onViewExistingRequest}
            >
              View Existing Request
            </Button>
          </div> */}
        </div>
      </Modal.Body>
    </Modal>
  );
};